import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {IAmplitudeLeadFormTrackingContext} from "../../application/types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {IAmplitudeOfferPromotionTrackingParamsWithItemId} from "./get_amplitude_offer_promotion_event_properties";

interface IGetAmplitudePromotionLeadFormTrackingContextParams {
    promotionTrackingContext: IAmplitudeOfferPromotionTrackingParamsWithItemId;
    applicationSource: ApplicationSource;
    ctaText: InquiryButtonTypeName | string;
}

export const getAmplitudePromotionLeadFormTrackingContext = (
    params: IGetAmplitudePromotionLeadFormTrackingContextParams
): IAmplitudeLeadFormTrackingContext => {
    const {promotionTrackingContext, applicationSource, ctaText} = params;

    return {
        inquiry_source: promotionTrackingContext.location,
        cta_text: ctaText,
        form_location: promotionTrackingContext.location,
        source_id: applicationSource,
        lead_type: "single_lead",
        item_id: promotionTrackingContext.itemId,
        ...(promotionTrackingContext.propertyId != null && {property_id: promotionTrackingContext.propertyId}),
        ...(promotionTrackingContext.promotionId != null && {promotion_id: promotionTrackingContext.promotionId}),
        creative_name: promotionTrackingContext.creativeName,
        promotion_name: promotionTrackingContext.promotionName,
        ...(promotionTrackingContext.promotionContent && {promotion_content: promotionTrackingContext.promotionContent})
    };
};
import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {IAmplitudeLeadFormTrackingContext} from "../../application/types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource} from "../../application/utils/form/application_form_source";
import {IAmplitudeOfferPromotionTrackingParamsWithItemId} from "./get_amplitude_offer_promotion_event_properties";

interface IGetAmplitudePromotionLeadFormTrackingContextParams {
    promotionTrackingContext: IAmplitudeOfferPromotionTrackingParamsWithItemId;
    applicationSource: ApplicationSource;
    ctaText: InquiryButtonTypeName | string;
}

export const getAmplitudePromotionLeadFormTrackingContext = (
    params: IGetAmplitudePromotionLeadFormTrackingContextParams
): IAmplitudeLeadFormTrackingContext => {
    const {promotionTrackingContext, applicationSource, ctaText} = params;

    return {
        inquiry_source: promotionTrackingContext.location,
        cta_text: ctaText,
        form_location: promotionTrackingContext.location,
        source_id: applicationSource,
        lead_type: "single_lead",
        item_id: promotionTrackingContext.itemId,
        ...(promotionTrackingContext.propertyId != null && {property_id: promotionTrackingContext.propertyId}),
        ...(promotionTrackingContext.promotionId != null && {promotion_id: promotionTrackingContext.promotionId}),
        creative_name: promotionTrackingContext.creativeName,
        promotion_name: promotionTrackingContext.promotionName,
        ...(promotionTrackingContext.promotionContent && {promotion_content: promotionTrackingContext.promotionContent})
    };
};
